import { Card } from "antd";
import StarIcon from "../_icons/StarIcon";
interface Props {
  data: any;
  viewOnly?: boolean;
}

export default function DetailsTemplateRating({ data }: Props) {
  return (
    <>
      <Card className="mt-4">
        <div className=" justify-start text-zinc-700 text-base font-medium">
          Rating - {data?.question_title}
        </div>

        <div className="mt-4 flex justify-center">
          <div className="flex items-center justify-center gap-10">
            {Array.from({ length: data?.rating_to_value || 0 }).map(
              (_, index) => (
                <div key={index} className="flex flex-col items-center">
                  <span className="text-zinc-700 text-base font-normal mb-2">
                    {index + 1}
                  </span>
                  <StarIcon
                    className={
                      index + 1 === data?.answer ? "fill-[#FFC700] stroke-[#FFC700]" : ""
                    }
                  />
                </div>
              ),
            )}
          </div>
        </div>
      </Card>
    </>
  );
}
